import { NotificationRepository } from "@/domain/repositories";
import { NotificationDataSource } from "../datasources/notification";
import { PushNotificationResponse } from "../dtos/responses";
import { NotificationMapper } from "@/domain/mappers";
import { PushNotification } from "@/domain/entities";

export class NotificationRepoImpl implements NotificationRepository {
  constructor(
    private readonly dataSource: NotificationDataSource,
    private readonly notificationMapper: NotificationMapper<PushNotificationResponse>,
  ) {}

  async getNotifications(): Promise<PushNotification[]> {
    const data = await this.dataSource.getNotifications();

    return data.map((elem) => this.notificationMapper.toDomain(elem));
  }
}
